module.exports = __webpack_public_path__ + "img/stand_boluo_1_cut.0f576b68.png";